import FilterOperator from "@mapmycustomers/shared/enum/FilterOperator";

export const BOOLEAN_FILTER_OPERATORS = [
  FilterOperator.IS_TRUE,
  FilterOperator.IS_FALSE,
  FilterOperator.EMPTY,
];
